import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=3bfb5e05&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=3bfb5e05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb5e05",
  null
  
)

export default component.exports